// extracted by mini-css-extract-plugin
module.exports = {"coverLink":"z-z","contentBox":"A-z","zapposPromoContainer":"B-z","zapposPromoGroupContainer":"C-z","promos":"D-z","bottom":"E-z","top":"F-z","right":"G-z","left":"H-z"};